import { ScrollArea, Table } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import type { TFunction } from 'i18next';

import { downloadFailedImportUsers } from '@/pages/NewAdminConsole/components/downloadFailedImportUsers';
import { convertRoleIDToInt } from '@/pages/NewAdminConsole/components/utils';
import { permissionApi } from '@/pages/NewAdminConsole/services/permissionApi';

interface OpenOptions {
  // 小屏适配：ScrollArea 最大高度减半
  compact?: boolean;
}

export const openImportErrorDetailModal = async (
  taskID: string | number,
  t: TFunction,
  { compact = false }: OpenOptions = {}
) => {
  try {
    const response = await permissionApi.getAsyncSimpleImportUsersResultDetail(String(taskID));

    if (!response.success) throw (response as any).error;

    if (!response.errorEntries || response.errorEntries.length === 0) return;

    const rows = response.errorEntries.map((err) => (
      <Table.Tr key={err.index}>
        <Table.Td>{convertRoleIDToInt(err.values)}</Table.Td>
        <Table.Td>{t(`adminConsole.tip.${err.errorCode.name}`)}</Table.Td>
      </Table.Tr>
    ));

    modals.openConfirmModal({
      title: t('adminConsole.newConsole.import.ImportErrorDetail'),
      size: 'lg',
      children: (
        <div>
          <ScrollArea.Autosize mah={compact ? 300 : 600} type="auto">
            <Table>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>{t('adminConsole.newConsole.import.import_table_value')}</Table.Th>
                  <Table.Th w={150}>{t('adminConsole.newConsole.import.import_table_error')}</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>{rows}</Table.Tbody>
            </Table>
          </ScrollArea.Autosize>
        </div>
      ),
      labels: { confirm: t('adminConsole.newConsole.import.downloadFailedImportUsersExcel'), cancel: '' },
      cancelProps: { display: 'none' },
      onConfirm: async () => {
        await downloadFailedImportUsers(response.errorEntries, t);
      },
    });
  } catch (error: any) {
    console.error(error);
    const translationError = t(`adminConsole.tip.${error.name}`);

    notifications.show({
      message:
        translationError !== `adminConsole.tip.${error.name}`
          ? translationError
          : t('adminConsole.newConsole.import.checkResultDetailFailed'),
      color: 'red',
    });
  }
};
